import React from "react";
import styled from "styled-components";
// import ProgressBar from "react-bootstrap/ProgressBar";
import empresaImg from "../static/images/flor-de-cana-logo.png";
const Line = styled.hr`
  margin: 1rem;
  border: 0;
  border: 1px solid #d5d5d5;
  opacity: 1;
`;

const EstadoAplicaciones = ({ aplicaciones }) => {
  const { Cargo, Empresa, Estado, Progreso } = aplicaciones;
  return (
    <div className="row m-0">
      <div className="col-md-12">
        <div className="boxWhiteAnch">
          <div className="text-left ml-4 mt-4">
            <p className="h1T">Estado de Aplicaciones</p>
            <div className="row m-0">
              <div className="col-md-2 p-0 m">
                <img
                  src={empresaImg}
                  className="iconEmpresas"
                  alt="Empresa"
                ></img>
              </div>
              <div className="col-md-10">
                <p className="h2T m-0">{Cargo}</p>
                <p className="p2T m-0">{Empresa}</p>
                <a href={Estado} target="blank" className="link1T m-0">
                  Ver estado
                </a>
              </div>
            </div>
            <div className="row m-0 mt-4">
              <div className="col-md-1 pl-0">
                <p className="p2T">0%</p>
              </div>
              <div className="col-md-9 m-0 mt-1 pl-1 pr-1">
                {/* <ProgressBar
                  className="progressbarestadoempresa"
                  variant="completebarestadoemres"
                  now={Progreso}
                /> */}
              </div>
              <div className="col-md-1 p-0">
                <p className="p2T">100%</p>
              </div>
            </div>
            <div className="row m-0">
              <div className="col-md-12">
                <div className="text-center">
                  <p className="p2T m-0">Estado: Revisión de CV's</p>
                </div>
              </div>
            </div>
            <Line className="mb-2" />
            <div className="row m-0 mb-2">
              <div className="col-md-12">
                <div className="text-center">
                  <a href="./" className="link2T">
                    Ver más
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EstadoAplicaciones;
